<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <div class="cockpit-view">
    <div>
      <div class="table-wrapper">
        <app-anzahl-mitarbeitende-nach-grungesamtheit [tableHeader]="tableHeaders[0]"
          [anzahlMitarbeitendeNachGrundgesamtheit]="anzahlMitarbeitendeNachGrundgesamtheit">
        </app-anzahl-mitarbeitende-nach-grungesamtheit>

        <h2>{{tableHeaders[1] | translate}}</h2>
        <app-chart-download-button (buttonClick)="exportTable('mitarbeitende', 0)">
          <h3>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h3>
        </app-chart-download-button>
        @if (personalbestand?.anzahlUndAnteileMitarbeitende) {
          <table id="mitarbeitende">
            <thead>
              <tr>
                <td rowspan="1" class="no-border"></td>
                <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right"><span class="strong">{{'i18n.common.gesamt' |
                translate }}</span></th>
                <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right"><span
                class="strong">{{'i18n.cockpit.card.chart.personalbestand.imMonatslohn' | translate }}</span></th>
                <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right"><span
                class="strong">{{'i18n.cockpit.card.chart.personalbestand.imStundenlohn' | translate }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="col" class="header centered bold border-bold-left border-bold-right"><span class="strong">{{'i18n.common.geschlecht' | translate
                }}</span></th>
                <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
                <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
                <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
                <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
                <th scope="col" class="centered">{{ 'i18n.common.anzahl' | translate }}</th>
                <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
              </tr>
              <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">{{'i18n.common.maenner' | translate }}</th>
                <td class="text-align-right">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlMaennerGesamt |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilMaennerGesamt }}</td>
                <td class="text-align-right">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlMaennerMonatslohn |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilMaennerMonatslohn }}</td>
                <td class="text-align-right">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlMaennerStundenlohn |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilMaennerStundenlohn }}</td>
              </tr>
              <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">{{'i18n.common.frauen' | translate }}</th>
                <td class="text-align-right">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlFrauenGesamt |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilFrauenGesamt }}</td>
                <td class="text-align-right">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlFrauenMonatslohn |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilFrauenMonatslohn }}</td>
                <td class="text-align-right">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlFrauenStundenlohn |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilFrauenStundenlohn }}</td>
              </tr>
              <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right border-bold-top">{{'i18n.common.gesamt' | translate }}</th>
                <td class="text-align-right border-bold-top">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlMitarbeitendeGesamt |
                numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right border-bold-top">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilMitarbeitendeGesamt}}</td>
                <td class="text-align-right border-bold-top">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlMitarbeitendeMonatslohn
                | numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right border-bold-top">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilMitarbeitendeMonatslohn }}</td>
                <td class="text-align-right border-bold-top">{{ personalbestand.anzahlUndAnteileMitarbeitende.anzahlMitarbeitendeStundenlohn
                | numberFormat: crtLocale }}</td>
                <td class="text-align-right border-bold-right border-bold-top">{{
                personalbestand.anzahlUndAnteileMitarbeitende.anteilMitarbeitendeStundenlohn }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="hint">
                <td class="hint" colspan="7">{{'i18n.cockpit.card.chart.personalbestand.basisGrundgesamtheit' | translate}}
                </td>
              </tr>
            </tfoot>
          </table>
        }
      </div>


      <app-chart-anzahl-anteil-mitarbeitende id="cmptChartAnzahlAnteilMitarbeitende" class="width-max-100-perc"
        [seriesAnzahlAnteilMitarbeitende]="seriesAnzahlAnteilMitarbeitende">
      </app-chart-anzahl-anteil-mitarbeitende>
    </div>
    <div>
      <div class="table-wrapper">
        <h2>{{tableHeaders[2] | translate}}</h2>

        <app-chart-download-button (buttonClick)="exportTable('durschnittlicherBeschäftigungsgrad', 1)">
          <h3>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h3>
        </app-chart-download-button>
        @if (personalbestand?.durchschnittlicherBeschaeftigungsgrad) {
          <table
            id="durschnittlicherBeschäftigungsgrad">
            <thead>
              <tr>
                <td style="width: 40%;" rowspan="1" class="no-border"></td>
                <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right"><span class="strong">{{'i18n.common.gesamt' |
                translate }}</span></th>
                <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right"><span
                class="strong">{{'i18n.cockpit.card.chart.personalbestand.imMonatslohn' | translate }}</span></th>
                <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right"><span
                class="strong">{{'i18n.cockpit.card.chart.personalbestand.imStundenlohn' | translate }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row" class="header centered bold border-bold-left border-bold-right"><span class="strong">{{'i18n.common.geschlecht' | translate
                }}</span></th>
                <td class="centered">{{ 'i18n.cockpit.card.chart.personalbestand.durschnitt' | translate }}</td>
                <td class="centered border-bold-right">{{ 'i18n.cockpit.card.chart.personalbestand.vae' | translate }}</td>
                <td class="centered">{{ 'i18n.cockpit.card.chart.personalbestand.durschnitt' | translate }}</td>
                <td class="centered border-bold-right">{{ 'i18n.cockpit.card.chart.personalbestand.vae' | translate }}</td>
                <td class="centered">{{ 'i18n.cockpit.card.chart.personalbestand.durschnitt' | translate }}</td>
                <td class="centered border-bold-right">{{ 'i18n.cockpit.card.chart.personalbestand.vae' | translate }}</td>
              </tr>
              <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">{{'i18n.common.maenner' | translate }}</th>
                <td class="text-align-right">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradMaennerGesamt }}</td>
                <td class="text-align-right border-bold-right">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentMaennerGesamt | numberFormat:
                crtLocale:2}}</td>
                <td class="text-align-right">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradMaennerMonatslohn }}</td>
                <td class="text-align-right border-bold-right">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentMaennerMonatslohn | numberFormat:
                crtLocale:2 }}</td>
                <td class="text-align-right">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradMaennerStundenlohn }}</td>
                <td class="text-align-right border-bold-right">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentMaennerStundenlohn | numberFormat:
                crtLocale:2 }}</td>
              </tr>
              <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">{{'i18n.common.frauen' | translate }}</th>
                <td class="text-align-right">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradFrauenGesamt }}</td>
                <td class="text-align-right border-bold-right">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentFrauenGesamt | numberFormat:
                crtLocale:2 }}</td>
                <td class="text-align-right">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradFrauenMonatslohn }}</td>
                <td class="text-align-right border-bold-right">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentFrauenMonatslohn | numberFormat:
                crtLocale:2 }}</td>
                <td class="text-align-right">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradFrauenStundenlohn }}</td>
                <td class="text-align-right border-bold-right">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentFrauenStundenlohn | numberFormat:
                crtLocale:2 }}</td>
              </tr>
              <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right border-bold-top">{{'i18n.common.gesamt' | translate }}</th>
                <td class="text-align-right border-bold-top">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradMitarbeitendeGesamt }}</td>
                <td class="text-align-right border-bold-right border-bold-top">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentMitarbeitendeGesamt |
                numberFormat: crtLocale:2 }}</td>
                <td class="text-align-right border-bold-top">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradMitarbeitendeMonatslohn }}</td>
                <td class="text-align-right border-bold-right border-bold-top">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentMitarbeitendeMonatslohn |
                numberFormat: crtLocale:2 }}</td>
                <td class="text-align-right border-bold-top">{{
                personalbestand.durchschnittlicherBeschaeftigungsgrad.beschaeftigungsgradMitarbeitendeStundenlohn }}</td>
                <td class="text-align-right border-bold-right border-bold-top">{{
                  personalbestand.durchschnittlicherBeschaeftigungsgrad.vollzeitequivalentMitarbeitendeStundenlohn |
                numberFormat: crtLocale:2 }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="hint">
                <td class="hint" colspan="7">{{'m1-m2.sprint10.cockpit.card.chart.personalbestand.basisGrundgesamtheit' |
                translate}}</td>
              </tr>
            </tfoot>
          </table>
        }
      </div>

      <app-chart-durchschnittlicher-beschaeftigungsgrad id="cmptChartDurchschnittlicherBeschaeftigungsgrad"
        class="width-max-100-perc" [durchschnittlicherBeschaeftigungsgrad]="durchschnittlicherBeschaeftigungsgrad">
      </app-chart-durchschnittlicher-beschaeftigungsgrad>
    </div>
  </div>
</div>
